function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Clear commented code
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import delay from 'lodash/delay';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
// import isEqual from 'lodash/isEqual';
import last from 'lodash/last';
import defer from 'lodash/defer';
import get from 'lodash/get';
import map from 'lodash/map';
import forOwn from 'lodash/forOwn';
import { MedicalRecordContext } from 'context';
import MetricConversions from 'libs/MetricConversions';
import StatsCalculations from 'libs/StatsCalculations';
import { getNowAsUtc } from 'helpers/datetime';
import { calculateData } from 'helpers/kpi';
import Button from 'components/Form/Button';
import Widget from 'components/Widget';
import Avatar from 'components/Avatar';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import intlShape from 'shapes/intlShape';
import patientShape from 'shapes/patientShape';
// import ArrowDownNegative from 'svg/arrow-down-negative.svg';
// import Calendar from 'svg/calendar-bold.svg';
// import Dashboard from 'svg/dashboard.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import AmbulatoryGlucoseProfile, { DailyGlucoseProfile } from 'modules/AmbulatoryGlucoseProfile';
// import OldDailyGlucoseProfile from 'modules/AmbulatoryGlucoseProfile/partials/DailyGlucoseProfile/index_old';
import CloudDrive from 'modules/CloudDrive';
import { calculateDateRanges, calculateDateRangesFromReadings } from 'helpers/dateRanges';
import { getStandards } from 'helpers/standards';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import { Indicators } from '../../modules/Kpi';
import RangePresets from '../../partials/RangePresets';
import ResultsRange from '../../partials/ResultsRange';
import MeasurementsModal from '../MeasurementsModal';
import EditPatientModal from '../EditPatientModal';
import MeasurementsTableWidget from '../MeasurementsTableWidget';
import GlucoseLevelDistributionWidget from '../GlucoseLevelDistributionWidget';
import MixedDistributionWidget from '../MixedDistributionWidget';
import SummaryTableWidget from '../SummaryTableWidget';
import TrendChartWidget from '../TrendChartWidget';
import ChartControls from '../TrendChartWidget/ChartControls';
import AgpTrendChartWidget from '../AgpTrendChartWidget';
import PrintableAgpBgmReport from '../PrintableAgpBgmReport';
import BloodGlucoseConcentrationReport from '../BloodGlucoseConcentrationReport';
import GlucoseConcentrationLevelsWidget from '../Widgets/GlucoseConcentrationLevelsWidget';
import AdditionalMeasurementsModal from '../AdditionalMeasurementsModal';
import styles from './Results.pcss';
var _React_PureComponent;
class Results extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { /* eslint-disable react/prop-types */ patient, phiSet, fromImports, fromImportsRange, readings, mode, aggregateBy, groupBy, calculationFormula, standards, measurements, isFetchReadingsInProgress, isSyncInProgress, relatedData: propsRelatedData, isPreviewResultMode, activeMeasurement } = props;
        if (!isPreviewResultMode) {
            // isSyncInProgress was removed here
            if (!phiSet || isFetchReadingsInProgress) {
                if (state.isInProgress) {
                    return null;
                }
                return {
                    isInProgress: true
                };
            }
        }
        const readingsCount = readings.length;
        const snaqImports = get(phiSet, 'imports.snaq');
        const { startDate, endDate, statsStart, statsEnd, flagFilters, statsFlagFilters } = state;
        const days = endDate && startDate ? endDate.diff(startDate, 'days', false) + 1 : 0;
        let daysWithReadings = 0;
        if (phiSet === state.phiSet && fromImports === state.fromImports && readingsCount === state.readingsCount && state.start === statsStart && state.end === statsEnd && mode === state.mode && aggregateBy === state.aggregateBy && groupBy === state.groupBy && calculationFormula === state.calculationFormula && flagFilters === statsFlagFilters && snaqImports === state.snaqImports) {
            if (!(isFetchReadingsInProgress && isSyncInProgress) && state.isInProgress) {
                return {
                    isInProgress: false
                };
            }
            return null;
        }
        let defaultStartDate;
        let { minDate, maxDate, startDate: sd, endDate: ed } = state;
        if (fromImports && fromImports !== state.fromImports) {
            minDate = fromImportsRange ? moment.unix(fromImportsRange.minResultDate).utc().startOf('day') : moment().utc();
            maxDate = fromImportsRange ? moment.unix(fromImportsRange.maxResultDate).utc().endOf('day') : moment().utc();
            defaultStartDate = minDate;
            sd = minDate;
            ed = maxDate;
        } else if (isPreviewResultMode) {
            const { defaultStartMoment, minMoment, maxMoment } = calculateDateRangesFromReadings(readings);
            defaultStartDate = defaultStartMoment;
            minDate = minMoment;
            maxDate = maxMoment;
            if (sd === null) {
                sd = defaultStartDate > minDate ? defaultStartDate : minDate;
            }
            if (ed === null) {
                ed = maxMoment;
            }
        } else if (phiSet !== state.phiSet && (!readingsCount || readingsCount !== state.readingsCount) || fromImports !== state.fromImports || snaqImports !== state.snaqImports) {
            const dataType = patient.dataType || 'BGM';
            const { defaultStartMoment, minMoment, maxMoment } = calculateDateRanges(phiSet, dataType);
            defaultStartDate = defaultStartMoment;
            minDate = minMoment;
            sd = defaultStartDate > minDate ? defaultStartDate : minDate;
            ed = maxDate;
            maxDate = maxMoment;
            ed = maxMoment;
        }
        if (maxDate.diff(minDate, 'months') >= 12) {
            minDate = maxDate.clone().subtract(1, 'years');
        }
        if (ed.diff(sd, 'months') >= 12) {
            sd = ed.clone().subtract(1, 'years');
        }
        const start = sd.clone().unix();
        const end = ed.clone().unix();
        const familyLinkId = get(patient, 'familyLinkId');
        const prevFamilyLinkId = get(state, 'familyLinkId');
        if (patient && (patient.id !== state.patientId || familyLinkId !== prevFamilyLinkId)) {
            // eslint-disable-next-line react/prop-types
            props.onClearFromImports();
            // eslint-disable-next-line react/prop-types
            props.onSetMode(constants.MODES[0]);
            if (phiSet) {
                props.onRangeChange(defaultStartDate, maxDate);
            }
            return _object_spread_props(_object_spread({}, calculateData([])), {
                patientId: patient.id,
                familyLinkId: patient.familyLinkId,
                phiSet: null,
                newResultsThreshold: sd,
                fromImports: null,
                data: [],
                relatedData: [],
                snaqImports: null,
                statsData: null,
                readingsCount: 0,
                mode,
                standards,
                measurements,
                aggregateBy,
                groupBy,
                calculationFormula,
                daysWithReadings,
                daysWithoutReadings: days,
                avgReadingsPerDay: 0,
                minDate,
                maxDate,
                startDate: sd,
                startDateUnix: sd.unix(),
                endDate: ed,
                endDateUnix: ed.unix(),
                start,
                end,
                flagFilters: [],
                statsFlagFilters: [],
                isInProgress: true
            });
        }
        if (fromImports && fromImports !== state.fromImports) {
            props.onRangeChange(minDate, maxDate);
            return {
                fromImports,
                minDate,
                maxDate,
                startDate: sd,
                endDate: ed,
                start,
                end
            };
        }
        const imports = get(phiSet, 'imports') || {};
        let newResultsThreshold = minDate.clone().unix();
        const today = getNowAsUtc().startOf('day').unix();
        forOwn(imports, (imp)=>{
            if (imp.documents) {
                const lastImport = last(imp.documents);
                if (lastImport && !lastImport.devices && lastImport.timestamp < today && lastImport.timestamp > newResultsThreshold) {
                    newResultsThreshold = lastImport.timestamp;
                }
            }
        });
        if (phiSet !== state.phiSet && !state.phiSet) {
            props.onRangeChange(defaultStartDate, maxDate);
            return {
                phiSet,
                newResultsThreshold,
                minDate,
                maxDate,
                startDate: sd,
                endDate: ed,
                start,
                end
            };
        }
        const data = filter(readings, (reading)=>reading.timestamp >= start && reading.timestamp <= end && (isEmpty(flagFilters) || includes(flagFilters, reading.flags)) && (!fromImports || includes(fromImports, reading.importDocumentId)));
        const agpData = filter(readings, (reading)=>reading.timestamp >= start && reading.timestamp <= end && (!fromImports || includes(fromImports, reading.importDocumentId)));
        const relatedData = filter(propsRelatedData, (relatedDataItem)=>{
            const { deviceDateTime, dateTime } = relatedDataItem;
            const timestamp = deviceDateTime || dateTime;
            return timestamp >= start && timestamp <= end;
        });
        let statsData = null;
        const daySeconds = 86400;
        for(let i = start; i < end; i += daySeconds){
            const idx = data.findIndex((reading)=>reading.timestamp >= i && reading.timestamp <= i + daySeconds);
            if (idx >= 0) {
                daysWithReadings++;
            }
        }
        let agpDaysWithReadings = 0;
        for(let i = start; i < end; i += daySeconds){
            const idx = agpData.findIndex((reading)=>reading.timestamp >= i && reading.timestamp <= i + daySeconds);
            if (idx >= 0) {
                agpDaysWithReadings++;
            }
        }
        const dataCount = data.length;
        if (mode !== 'ALL') {
            const hoursBreakpoints = get(phiSet, 'customRanges') || constants.HOURS_BREAKPOINTS;
            const statsCalculations = new StatsCalculations(data, props.deviceMode !== 'AGP' ? props.standards : getStandards(null, null, null), hoursBreakpoints);
            if (mode === 'AGGREGATED') {
                statsData = statsCalculations.aggregate(aggregateBy, calculationFormula);
            } else if (mode === 'GROUPED') {
                statsData = statsCalculations.group(groupBy, calculationFormula);
            }
        }
        let range = null;
        if (!(state.minDate && state.maxDate && state.minDate.isSame(minDate) && state.maxDate.isSame(maxDate))) {
            range = {
                minDate,
                maxDate,
                startDate: sd,
                endDate: ed,
                start,
                end
            };
        }
        let progressIndicators = null;
        if (phiSet && readings) {
            progressIndicators = {
                isInProgress: false
            };
        }
        const agpCalculatedData = _object_spread_props(_object_spread({}, calculateData(agpData)), {
            data: agpData,
            daysWithReadings: agpDaysWithReadings,
            daysWithoutReadings: Math.max(days - daysWithReadings, 0)
        });
        return _object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({}, calculateData(data)), {
            agpData: agpCalculatedData,
            patient,
            phiSet,
            newResultsThreshold,
            fromImports,
            data,
            relatedData,
            snaqImports,
            statsData,
            dataCount,
            mode,
            aggregateBy,
            groupBy,
            calculationFormula,
            readingsCount,
            daysWithReadings,
            days,
            standards,
            measurements,
            activeMeasurementTimestamp: activeMeasurement ? activeMeasurement.timestamp : 0,
            daysWithoutReadings: Math.max(days - daysWithReadings, 0),
            avgReadingsPerDay: days && (dataCount / days).toFixed(2)
        }), range), {
            statsStart: start,
            statsEnd: end,
            statsFlagFilters: flagFilters
        }), progressIndicators);
    }
    componentDidUpdate(prevProps, prevState) {
        const { highlightedDates } = this.props;
        if (this.props.resultsIsInProgress !== this.state.isInProgress) {
            this.props.setResultsInProgress(this.state.isInProgress);
        }
        if (this.state.startDate && this.state.endDate && (this.state.startDate !== prevState.startDate || this.state.endDate !== prevState.endDate || this.state.isInProgress !== prevState.isInProgress && !this.state.isInProgress)) {
            const start = this.state.startDate.format('YYYY-MM-DD');
            const end = this.state.endDate.format('YYYY-MM-DD');
            if (start !== highlightedDates[0] || end !== highlightedDates[highlightedDates.length - 1]) {
                // Needed to be called after data loading. For better fix start/end dates should be stored in store
                defer(()=>this.props.selectHighlightedDates({
                        start,
                        end
                    }));
            }
        }
        if (prevState.patientId !== this.state.patientId || prevState.phiSet !== this.state.phiSet || prevState.start !== this.state.start || prevState.data !== this.state.data || prevState.end !== this.state.end || prevState.dataCount !== this.state.dataCount || prevState.aggregateBy !== this.state.aggregateBy || prevProps.mode !== this.props.mode || prevProps.calculationFormula !== this.props.calculationFormula || prevProps.isStoreMeasurementsInProgress && !this.props.isStoreMeasurementsInProgress && !this.props.hasStoreMeasurementsErrors) {
            this.props.onDumpReportsState(_object_spread_props(_object_spread({}, this.state), {
                readings: this.props.readings,
                standards: this.standards,
                timeSeriesResources: this.timeSeriesResourcesInRange,
                accountPatientProfile: this.isPatientMode ? this.props.accountPatientProfile : this.props.patient
            }));
        }
    }
    componentWillUnmount() {
        this.props.setResultsInProgress(true);
        this.props.setPrintMode(false);
    }
    onAddNote(noteType, payload) {
        payload.start = this.state.start;
        payload.end = this.state.end;
        this.props.onAddNote(noteType, payload);
    }
    /*
    This method is called after delay because if endDate is being entered manually in the input passed value
    is incorrect
   */ onChangeRange() {
        const { startDate, endDate } = this.state;
        if (!startDate || !endDate) {
            this.setState((prevState)=>({
                    startDate: moment.unix(prevState.start).utc(),
                    endDate: moment.unix(prevState.end).utc()
                }));
            return;
        }
        const start = startDate.utc().clone().unix();
        const end = endDate.utc().clone().unix();
        if (start === this.state.start && end === this.state.end) {
            return;
        }
        this.setState({
            start,
            end
        });
        this.props.onRangeChange(startDate, endDate);
    }
    onDatesChange(startDate, endDate) {
        this.setState({
            startDate,
            endDate
        });
    }
    onToggleFlagFilter(flag) {
        this.setState((prevState)=>{
            const { flagFilters } = prevState;
            if (flag === 'All') {
                return {
                    flagFilters: []
                };
            }
            if (includes(flagFilters, flag)) {
                return {
                    flagFilters: filter(flagFilters, (ff)=>ff !== flag)
                };
            }
            return {
                flagFilters: [
                    ...flagFilters,
                    flag
                ]
            };
        });
    }
    get timeSeriesResourcesInRange() {
        if (!this.props.timeSeriesResources) return [];
        return filter(this.props.timeSeriesResources, ({ timestamp })=>timestamp >= this.state.start && timestamp <= this.state.end);
    }
    get customRanges() {
        return get(this.props.phiSet, 'customRanges') || map(constants.HOURS_BREAKPOINTS, (hb)=>[
                ...hb
            ]);
    }
    get standards() {
        return this.props.deviceMode !== 'AGP' ? this.props.standards : this.agpStandards;
    }
    get widgets() {
        const { customRanges } = this;
        const onDatesChange = (startDate, endDate)=>{
            this.onDatesChange(startDate, endDate);
            delay(()=>this.onChangeRange());
        };
        return {
            AgpTrendChartWidget: /*#__PURE__*/ _jsx(AgpTrendChartWidget, {
                conversion: this.metricConversions.bloodGlucoseConcentration,
                direction: this.props.direction,
                standards: this.props.standards,
                isInProgress: this.state.isInProgress,
                start: this.state.start,
                end: this.state.end,
                onDatesChange: onDatesChange,
                data: this.statsData
            }, "AgpTrendChartWidget"),
            TrendChartWidget: /*#__PURE__*/ _jsx(TrendChartWidget, {
                renderControls: false,
                phiSetDocumentId: this.props.phiSetDocumentId,
                phiSet: this.state.phiSet,
                data: this.statsData,
                dataType: this.props.patient && this.props.patient.dataType || 'BGM',
                relatedData: this.state.relatedData,
                timeSeriesResources: this.timeSeriesResourcesInRange,
                measurements: this.props.measurements,
                start: this.state.start,
                end: this.state.end,
                conversion: this.metricConversions.bloodGlucoseConcentration,
                direction: this.props.direction,
                standards: this.standards,
                customRanges: customRanges,
                activePointTimestamp: this.state.activeMeasurementTimestamp,
                renderDatePresets: (className)=>this.renderDatePresets(className, true),
                renderFlagFilters: ()=>this.renderFlagFilters(),
                onSetActivePointTimestamp: (activeMeasurementTimestamp)=>this.setState({
                        activeMeasurementTimestamp
                    }),
                onUpdatePhiSet: this.props.onUpdatePhiSet,
                onAddNote: this.props.onAddNote,
                isReadOnly: this.props.isReadOnly,
                isInProgress: this.state.isInProgress,
                highlightedReadings: this.props.highlightedReadings
            }, "TrendChartWidget"),
            ChartControls: /*#__PURE__*/ _jsx(Widget, {
                widgetId: constants.CHART_CONTROLS_WIDGET,
                isNoHeader: true,
                children: /*#__PURE__*/ _jsx(ChartControls, {
                    start: this.state.start,
                    end: this.state.end,
                    renderDatePresets: (className)=>this.renderDatePresets(className, true),
                    renderFlagFilters: ()=>this.renderFlagFilters(),
                    isInProgress: this.state.isInProgress
                })
            }, "ChartControlsWidget"),
            MeasurementsTableWidget: /*#__PURE__*/ _jsx(MeasurementsTableWidget, {
                phiSet: this.props.phiSet,
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                readings: this.state.data,
                timeSeriesResources: this.timeSeriesResourcesInRange,
                relatedData: this.state.relatedData,
                customRanges: customRanges,
                activeReadingTimestamp: this.state.activeMeasurementTimestamp,
                headerMessage: messages.headers.measurementsTable,
                isInProgress: this.state.isInProgress
            }, "MeasurementsTableWidget"),
            MeasurementsTableWidgetWithoutMyDownloads: /*#__PURE__*/ _jsx(MeasurementsTableWidget, {
                phiSet: this.props.phiSet,
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                readings: this.state.data,
                timeSeriesResources: this.timeSeriesResourcesInRange,
                relatedData: this.state.relatedData,
                customRanges: customRanges,
                activeReadingTimestamp: this.state.activeMeasurementTimestamp,
                headerMessage: messages.headers.measurementsTable,
                isInProgress: this.state.isInProgress,
                isMyDownloadsHidden: true,
                onCellClick: (activeMeasurementTimestamp)=>this.setState({
                        activeMeasurementTimestamp
                    })
            }, "MeasurementsTableWidgetWithoutMyDownloads"),
            GlucoseLevelDistributionWidget: /*#__PURE__*/ _jsx(GlucoseLevelDistributionWidget, {
                flagFilters: this.state.flagFilters,
                standards: this.standards,
                readings: this.state.data,
                isInProgress: this.state.isInProgress,
                onAddNote: this.props.onAddNote ? (noteType, payload)=>this.onAddNote(noteType, payload) : null
            }, "GlucoseLevelDistributionWidget"),
            MixedDistributionWidget: /*#__PURE__*/ _jsx(MixedDistributionWidget, {
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                flagFilters: this.state.flagFilters,
                readings: this.state.data,
                isInProgress: this.state.isInProgress
            }, "MixedDistributionWidget"),
            SummaryTableWidget: /*#__PURE__*/ _jsx(SummaryTableWidget, {
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                patientId: this.state.patientId,
                readings: this.state.data,
                customRanges: customRanges,
                isInProgress: this.state.isInProgress
            }, "SummaryTableWidget"),
            ContentBar: this.renderContentBar(),
            KPIs: this.renderKPIs(),
            PatientHeader: this.renderPrintableHeader(),
            BloodGlucoseConcentrationReport: /*#__PURE__*/ _jsx(BloodGlucoseConcentrationReport, {
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                calculationFormula: this.props.calculationFormula,
                phiSet: this.props.phiSet,
                accountPatientProfile: _object_spread({}, this.props.accountPatientProfile, this.props.patient),
                customRanges: customRanges
            }, "BloodGlucoseConcentrationReport"),
            GlucoseConcentrationLevelsWidget: /*#__PURE__*/ _jsx(GlucoseConcentrationLevelsWidget, {
                readings: this.state.data,
                start: this.state.start,
                end: this.state.end,
                isInProgress: this.state.isInProgress,
                onAddNote: this.props.onAddNote ? (noteType, payload)=>this.onAddNote(noteType, payload) : null
            }),
            DaysSelector: /*#__PURE__*/ _jsx(Widget, {
                widgetId: constants.DAYS_SELECTION_WIDGET,
                headerMessage: messages.headers.dailyGlucoseProfile,
                children: /*#__PURE__*/ _jsx(DailyGlucoseProfile, {
                    patient: this.props.patient,
                    phiSet: this.props.phiSet,
                    phiSetDocumentId: this.props.phiSetDocumentId,
                    isInProgress: this.state.isInProgress,
                    onDatesChange: onDatesChange
                })
            }, "DaysSelectorWidget"),
            PrintableAgpBgmReport: /*#__PURE__*/ _jsx(PrintableAgpBgmReport, {
                conversion: this.metricConversions.bloodGlucoseConcentration,
                standards: this.standards,
                firstName: get(_object_spread({}, this.props.accountPatientProfile, this.props.patient), 'firstName', ''),
                lastName: get(_object_spread({}, this.props.accountPatientProfile, this.props.patient), 'lastName', ''),
                readings: this.state.data,
                preMealReadings: this.state.preMealReadings,
                postMealReadings: this.state.postMealReadings,
                strictPreMealReadings: this.state.strictPreMealReadings,
                strictPostMealReadings: this.state.strictPostMealReadings,
                daysWithReadings: this.state.daysWithReadings,
                daysWithoutReadings: this.state.daysWithoutReadings,
                readingsWithoutFlag: this.state.readingsWithoutFlag,
                glucoseConcentrationLevelBottomValues: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES
            }, "PrintableAgpBgmReport")
        };
    }
    get statsData() {
        if (this.state.statsData) {
            return this.state.statsData;
        }
        return this.state.data;
    }
    get isPatientMode() {
        return !!this.props.isPatientMode;
    }
    get isPrintMode() {
        return this.props.printMode;
    }
    renderKPIs() {
        const { data: readings, preMealReadings, postMealReadings, daysWithReadings, daysWithoutReadings, isInProgress, readingsWithoutFlag } = this.state;
        const onAddNote = this.props.onAddNote ? (noteType, payload)=>this.onAddNote(noteType, payload) : null;
        return /*#__PURE__*/ _jsx(Indicators, {
            readings: readings,
            preMealReadings: preMealReadings,
            postMealReadings: postMealReadings,
            daysWithReadings: daysWithReadings,
            daysWithoutReadings: daysWithoutReadings,
            readingsWithoutFlag: readingsWithoutFlag,
            isInProgress: isInProgress,
            onAddNote: onAddNote
        }, "KPIs");
    }
    renderPrintablePatient() {
        const { firstName, lastName } = this.props.patient || {};
        const { firstName: accountFirstName, lastName: accountLastName } = this.props.accountPatientProfile || {};
        return /*#__PURE__*/ _jsx("div", {
            className: "col",
            children: /*#__PURE__*/ _jsx("div", {
                className: cn('row align-items-center', styles.reportInfo),
                children: this.isPatientMode || firstName || lastName || accountFirstName || accountLastName ? /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: cn('text--h3', styles.reportInfo__label),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.info))
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "text--h1 mb-2",
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.for)),
                                        /*#__PURE__*/ _jsx("br", {})
                                    ]
                                }),
                                this.isPatientMode ? `${accountFirstName} ${accountLastName}` : `${firstName} ${lastName}`
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.reportInfo__time,
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.generated)),
                                ' ',
                                moment().format('l')
                            ]
                        })
                    ]
                }) : null
            })
        });
    }
    /*
    renderHeaderToggles() {
      // @TODO: Check if this method is obsolete
      if (!this.props.featureToggles.includes(App.constants.FEATURE_TOGGLES.featureCgm)) {
        return null;
      }
      const { setDashboardLayout, dashboardLayout } = this.props;
      const { isInProgress } = this.state;
      return (
        <div className={styles.topBar}>
          <div className={cn(styles.topBar__left, { fadingLoader: isInProgress })}>
            <Button
              styleModifier="transparent"
              className={
                cn(
                  styles.topBar__button,
                  {
                    [styles['topBar__button--active']]: isEqual(dashboardLayout, constants.DASHBOARD_LAYOUTS.bgm),
                  },
                )
              }
              isDisabled={isInProgress}
              onClick={() => setDashboardLayout(constants.DASHBOARD_LAYOUTS.bgm)}
            >
              <Dashboard />
              <FormattedMessage {...messages.buttons.standard} />
            </Button>
            <Button
              styleModifier="transparent"
              className={
                cn(
                  styles.topBar__button,
                  {
                    [styles['topBar__button--active']]: isEqual(dashboardLayout, constants.DASHBOARD_LAYOUTS.agp),
                  },
                )
              }
              isDisabled={isInProgress}
              onClick={() => setDashboardLayout(constants.DASHBOARD_LAYOUTS.agp)}
            >
              <Dashboard />
              <FormattedMessage {...messages.buttons.agpcgm} />
            </Button>
          </div>
        </div>
      );
    }
 */ renderHeader() {
        const { isInProgress } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: "widget widget--noHeader",
            "data-testid": "patient-header",
            children: /*#__PURE__*/ _jsx("div", {
                className: "widget__content",
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.headerWrapper,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.header,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: cn('row align-items-center', styles.patientHeader),
                            children: this.props.renderPatientHeader(isInProgress)
                        })
                    })
                })
            })
        });
    }
    renderPrintableHeader() {
        const { startDate, endDate, days } = this.state;
        const { activeClinicMembership } = this.props;
        const clinic = get(activeClinicMembership, 'clinic');
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                !this.isPatientMode && clinic && /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.CLINIC_DETAILS_HEADER_WIDGET,
                    isNoHeader: true,
                    className: styles.printableClinicDetailsWrapper,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableClinicDetails,
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    imgClassName: styles.printableClinicDetails__logo,
                                    avatarImg: clinic.logo
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: cn('text--normal', styles.printableClinicDetails__info),
                                    children: [
                                        clinic.name,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        clinic.street,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        clinic.zipCode,
                                        " ",
                                        clinic.city
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.PATIENT_DETAILS_HEADER_WIDGET,
                    isNoHeader: true,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-4",
                                children: this.renderPrintablePatient()
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-8 align-items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.printableHeaderFeatures,
                                        children: this.renderKPIs()
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.printableHeaderRow,
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: styles.printableHeaderRow__date,
                                            children: [
                                                /*#__PURE__*/ _jsxs("h3", {
                                                    className: "text--h3",
                                                    children: [
                                                        startDate && startDate.format('ll'),
                                                        " - ",
                                                        endDate && endDate.format('ll')
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("h4", {
                                                    className: "text--h3",
                                                    children: [
                                                        "(",
                                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.presets.days), {
                                                            values: {
                                                                number: days
                                                            }
                                                        })),
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
    renderDatePresets(className, isStandalone = false) {
        const { startDate, endDate, minDate, maxDate, newResultsThreshold, isInProgress } = this.state;
        const onChange = (newStartDate, newEndDate)=>{
            this.onDatesChange(newStartDate, newEndDate);
            if (!isStandalone) {
                return;
            }
            delay(()=>this.onChangeRange(), 100);
        };
        const newResultsStartDate = moment.unix(newResultsThreshold).utc();
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('btn-group', styles.chartControls__filters, styles.chartControls__wrapper, className),
            children: [
                /*#__PURE__*/ _jsx(RangePresets, {
                    startDate: startDate,
                    endDate: endDate,
                    minDate: minDate,
                    maxDate: maxDate,
                    newResultsStartDate: newResultsStartDate,
                    isInProgress: isInProgress,
                    onChange: onChange
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.buttonsSeparator,
                    children: /*#__PURE__*/ _jsx("div", {})
                }),
                /*#__PURE__*/ _jsx(ResultsRange, {
                    startDate: startDate,
                    endDate: endDate,
                    minDate: minDate,
                    maxDate: maxDate,
                    isInProgress: isInProgress,
                    onChange: (newStartDate, newEndDate)=>this.onDatesChange(newStartDate, newEndDate),
                    onClose: ()=>delay(()=>this.onChangeRange(), 100)
                })
            ]
        });
    }
    renderFlagFilters() {
        const { flagFilters, isInProgress } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: cn('btn-group', styles.chartControls__filters, styles.chartControls__wrapper),
            children: map(App.messages.flags, (flagMessage, flag)=>/*#__PURE__*/ _jsx(Button, {
                    styleModifier: "quinary",
                    className: cn('btn--filled', {
                        'btn--active': isEmpty(flagFilters) && flag === 'All' || includes(flagFilters, flag)
                    }),
                    data: {
                        'data-for': 'globalTooltip',
                        'data-tip': this.props.intl.formatMessage(flagMessage)
                    },
                    isDisabled: isInProgress,
                    onClick: ()=>this.onToggleFlagFilter(flag),
                    children: /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                        flag: flag,
                        className: "btn__icon"
                    })
                }, flag))
        });
    }
    renderContentBar() {
        return /*#__PURE__*/ _jsx(Fragment, {
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.alertsContainer,
                children: this.props.renderContextAlerts && this.props.renderContextAlerts()
            })
        }, "ContentHeader");
    }
    renderWidgets() {
        if (!process.env.BROWSER || !this.props.standards) {
            return null;
        }
        const { dashboardLayout } = this.props;
        return map(dashboardLayout, (widget)=>{
            if (Array.isArray(widget)) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: map(widget, (element)=>{
                        const items = element.split(';');
                        return /*#__PURE__*/ _jsx("div", {
                            className: items[0],
                            children: this.widgets[items[1]]
                        }, `item-${items[1]}`);
                    })
                }, `${widget.toString()}`);
            }
            return this.widgets[widget];
        });
    }
    renderEditPatientModal() {
        if (this.props.isReadOnly || this.isPatientMode) {
            return null;
        }
        return /*#__PURE__*/ _jsx(EditPatientModal, {
            metricConversions: this.metricConversions,
            patient: this.props.patient,
            phiSet: this.props.phiSet,
            phiSetDocumentId: this.props.phiSetDocumentId,
            isPatientMode: this.isPatientMode,
            onSuccess: this.props.onMeasurementsSuccess
        });
    }
    renderMeasurementsModal() {
        if (!this.isPatientMode) {
            return null;
        }
        return /*#__PURE__*/ _jsx(MeasurementsModal, {
            metricConversions: this.metricConversions,
            patient: this.props.patient,
            phiSet: this.props.phiSet,
            phiSetDocumentId: this.props.phiSetDocumentId,
            isPatientMode: this.isPatientMode,
            onSuccess: this.props.onMeasurementsSuccess,
            standards: this.props.standards
        });
    }
    render() {
        // TODO: Move to parent components if this.props.patient usages is changed to context
        return /*#__PURE__*/ _jsx(MedicalRecordContext.Provider, {
            value: this.props.patient,
            children: /*#__PURE__*/ _jsxs("div", {
                "data-testid": "patient-result-page",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn('widgets', {
                            'widgets--noGutters': this.isPrintMode
                        }),
                        children: [
                            !this.isPrintMode && this.renderHeader(),
                            this.renderWidgets()
                        ]
                    }),
                    this.renderMeasurementsModal(),
                    this.renderEditPatientModal(),
                    /*#__PURE__*/ _jsx(AdditionalMeasurementsModal, {})
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.metricConversions = new MetricConversions(props.metricsUnits);
        this.state = {
            patientId: null,
            phiSet: null,
            newResultsThreshold: 0,
            fromImports: [],
            readingsCount: 0,
            data: [],
            relatedData: [],
            statsData: null,
            mode: null,
            aggregateBy: null,
            groupBy: null,
            calculationFormula: null,
            daysWithReadings: null,
            daysWithoutReadings: null,
            minDate: null,
            maxDate: null,
            startDate: null,
            endDate: null,
            start: null,
            end: null,
            statsStart: null,
            statsEnd: null,
            activeMeasurementTimestamp: null,
            flagFilters: [],
            statsFlagFilters: [],
            isInProgress: true,
            preMealReadings: [],
            postMealReadings: [],
            isFetchReadingsInProgress: false
        };
        this.agpStandards = getStandards(null, null, null);
    }
}
_define_property(Results, "propTypes", {
    // Explicit props
    isPatientMode: PropTypes.bool,
    isPreviewResultMode: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    patient: patientShape,
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    readings: PropTypes.array,
    timeSeriesResources: PropTypes.array,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    highlightedDates: PropTypes.arrayOf(PropTypes.string),
    renderPatientHeader: PropTypes.func,
    renderContextAlerts: PropTypes.func,
    highlightedReadings: PropTypes.array,
    relatedData: PropTypes.array,
    measurements: PropTypes.array,
    deviceMode: PropTypes.string,
    // Explicit action
    onRangeChange: PropTypes.func,
    onMeasurementsSuccess: PropTypes.func,
    onUpdatePhiSet: PropTypes.func,
    onAddNote: PropTypes.func,
    // Implicit props
    direction: App.shapes.direction,
    // featureToggles        : PropTypes.arrayOf(PropTypes.string),
    activeClinicMembership: Account.shapes.clinicMembership,
    printMode: PropTypes.bool,
    metricsUnits: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    dashboardLayout: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])).isRequired,
    // deviceMode        : PropTypes.oneOf(constants.DEVICES_MODES),
    mode: PropTypes.oneOf(constants.MODES),
    intl: intlShape,
    calculationFormula: PropTypes.oneOf([
        ...constants.CALCULATION_FORMULAS,
        ...constants.CALCULATION_FORMULAS_CGM
    ]),
    resultsIsInProgress: PropTypes.bool,
    isStoreMeasurementsInProgress: PropTypes.bool,
    hasStoreMeasurementsErrors: PropTypes.bool,
    // Implicit actions
    // setDashboardLayout     : PropTypes.func,
    selectHighlightedDates: PropTypes.func,
    setResultsInProgress: PropTypes.func,
    setPrintMode: PropTypes.func,
    onDumpReportsState: PropTypes.func,
    activeMeasurement: PropTypes.object
});
const mapStateToProps = (state)=>({
        mode: selectors.mode(state),
        deviceMode: selectors.deviceMode(state),
        fromImports: selectors.fromImports(state),
        fromImportsRange: selectors.fromImportsRange(state),
        aggregateBy: selectors.aggregateBy(state),
        groupBy: selectors.groupBy(state),
        calculationFormula: selectors.calculationFormula(state),
        dashboardLayout: selectors.dashboardLayout(state),
        resultsIsInProgress: selectors.resultsIsInProgress(state),
        activeMeasurement: selectors.selectedReading(state),
        direction: App.selectors.direction(state),
        printMode: App.selectors.printMode(state),
        // featureToggles              : App.selectors.featureToggles(state),
        metricsUnits: Account.selectors.metricsUnits(state),
        accountPatientProfile: Account.selectors.patientProfileExtended(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        highlightedDates: AmbulatoryGlucoseProfile.selectors.highlightedDates(state),
        isFetchReadingsInProgress: CloudDrive.selectors.isFetchReadingsInProgress(state),
        isStoreMeasurementsInProgress: CloudDrive.selectors.isStoreMeasurementsInProgress(state)
    });
const mapDispatchToProps = (dispatch)=>({
        setPrintMode: (printMode)=>dispatch(App.actions.setPrintMode(printMode)),
        onDumpReportsState: (reportsState)=>dispatch(actions.dumpReportsState(reportsState)),
        onClearFromImports: ()=>dispatch(actions.clearFromImports()),
        onSetMode: (mode)=>dispatch(actions.setMode(mode)),
        // setDashboardLayout     : (layout) => dispatch(actions.setDashboardLayout(layout)),
        selectHighlightedDates: (range)=>dispatch(AmbulatoryGlucoseProfile.actions.selectHighlightedDates(range)),
        setResultsInProgress: (isInProgress)=>dispatch(actions.setResultsInProgress(isInProgress))
    });
const ConnectedResults = connect(mapStateToProps, mapDispatchToProps)(injectIntl(Results));
export default withStyles(styles)(ConnectedResults);
